import fetch from '@/config/fetch';
import fetchNew from '../config/fetchNew';

/**
 * 分公司管理
 */
export const companyList = data => fetch('/platform/essOrganization/companyList', data, 'GET');

export const companyIsEnable = id => fetch(`/platform/essOrganization/isEnable/${id}`, {}, 'POST');

export const companyDetail = id => fetch(`/platform/essOrganization/companyDetail/${id}`, {}, 'GET');

export const addCompany = data => fetch('/platform/essOrganization/addCompany', data, 'POST');

export const updateOrganization = data => fetch('/platform/essOrganization/updateOrganization', data, 'POST');

/**
 * 部门管理
 */
export const qryDepartment = data => fetch('/platform/department/pageList', data, 'GET');

export const qryDepartment1 = data => fetch('/platform/department/selectDepartmentAll', {}, 'GET');

// 部门新增接口
export const addDepartment = data => fetch('/platform/department/add', data, 'POST');

// 删除
export const isDeleteDepartment = id => fetch(`/platform/department/delDepart/${id}`, {}, 'POST');

// 启用/禁用
export const isEnableDepartment = id => fetch(`/platform/department/updateEnable/${id}`, {}, 'POST');

// 部门修改接口
export const editDepartment = data => fetch('/platform/department/updateDepart', data, 'POST');

/**
 * pc角色管理
 */

export const loadMenuGetRolePage = data => fetch('/web/roles/getRolePage', data, 'POST');

export const addRoleEmp = data => fetch('/platform/sys/essRole/addRole', data, 'POST');

export const isEnableRole = id => fetch(`/platform/sys/essRole/updateEnable/${id}`, {}, 'POST');
// 删除
export const isDeleteRole = id => fetch(`/platform/sys/essRole/delRole/${id}`, {}, 'POST');
// 获取角色权限
export const getMenuByRoleId = data => fetch('/web/menus/getMenuByRoleId', data, 'GET');

export const updateMenuByRole = data => fetch('/web/menus/updateMenuByRole', data, 'POST');

export const updateRole = data => fetch('/platform/sys/essRole/updateRole', data, 'POST');

export const seAllMenu = data => fetch('/web/menus/seAllMenu', data, 'POST');


/**
 * app角色管理
 */
// 分页查询
export const appRolePageList = data => fetch('/platform/app/role/pageList', data, 'GET');
// 新增
export const addAppRole = data => fetch('/platform/app/role/add', data, 'POST');
// 修改
export const updateAppRole = data => fetch('/platform/app/role/update', data, 'POST');
// 删除
export const deleteAppRole = data => fetch('/platform/app/role/delete', data, 'POST');
// 启用/禁用
export const isEnableAppRole = data => fetch('/platform/app/role/isEnable', data, 'POST');
// 获取菜单
export const seAllAppMenu = data => fetch('/platform/app/menu/getAppMenu', data, 'POST');
// 获取角色权限
export const getMenuByAppRole = data => fetch('/platform/app/roleMenu/getAppMenuAuthority', data, 'GET');
// 设置权限
export const setMenuAuthority = data => fetch('/platform/app/roleMenu/setMenuAuthority', data, 'POST');


/**
 * 用户管理
 */

export const qryEmployeeInfo = data => fetch('/platform/essEmployee/pageList', data, 'GET');

export const isEnableEmp = id => fetch(`/platform/essEmployee/updateEnable/${id}`, {}, 'POST');

export const rePasswordByUser = id => fetch(`/platform/essEmployee/resetPassword/${id}`, {}, 'POST');

export const addEmployee = data => fetch('/platform/essEmployee/add', data, 'POST');

export const qryDepartmentInfo = data => fetch('/web/organization/qryDepartment', data, 'POST');

// 获取所有部门
export const selectDepartmentAll = data => fetch('/platform/department/selectDepartmentAll', data, 'GET');

// 获取所有PC角色
export const selectRoleAll = data => fetch('/platform/sys/essRole/selectRoleAll', data, 'GET');
// 获取所有App角色
export const selectAppRoleAll = data => fetch('/platform/app/role/selAll', data, 'GET');

export const qryRoleSelectRoleAll = data => fetch('/web/roles/selectRoleAll', data, 'GET');

// export const getCompanyParam = ( data ) => fetch( `/platform/paramCategoryAttr/getCompanyParam`, data, 'GET')

export const qryEmployeeDetail = id => fetch(`/platform/essEmployee/detail/${id}`, {}, 'GET');

export const editEmployee = data => fetch('/platform/essEmployee/update', data, 'POST');

/**
 * 委托商管理
 */
export const customerInfoPageList = data => fetch('/platform/sys/customerInfo/pageList', data, 'GET');

export const customerInfoSelectList = data => fetch('/platform/sys/customerInfo/selectList', data, 'POST');

export const customerTypeSelectList = data => fetch('/platform/sys/customerType/selectList', data, 'POST');

// export const customerNature = ( data ) => fetch( `/platform/sys/dict/selectDictListByType/customerNature`, data, 'POST')
export const customerNature = data => fetch('/platform/paramCategoryAttr/selectCategoryAttr', data, 'GET');

export const customerDetail = id => fetch(`/platform/sys/customerInfo/detail/${id}`, id, 'GET');

// export const companyScale = ( data ) => fetch( `/platform/sys/dict/selectDictListByType/companyScale`, data, 'POST')
export const companyScale = data => fetch('/platform/paramCategoryAttr/selectCategoryAttr', data, 'GET');

export const getIncrement = data => fetch('/platform/inspur/getIncrement', data, 'GET');

export const getMasterDate = data => fetch('platform/inspur/getMasterDate', data, 'POST');

export const getPageList = data => fetch('/platform/supplierInfoTransition/pageList', data, 'GET');

export const dropDownData = data => fetch('/platform/sys/customerInfo/dropDownData', data, 'GET');

export const endCooperation = data => fetch('/platform/sys/customerInfo/endCooperation/', data, 'POST');

export const basicInfoUpdate = data => fetch('/platform/sys/customerInfo/basicInfoUpdate', data, 'POST');

export const infoChange = data => fetch('/platform/sys/customerExamine/infoChange', data, 'POST');

export const customerAdd = data => fetch('/platform/sys/customerInfo/add', data, 'POST');

export const customerEdit = data => fetch('/platform/sys/customerInfo/update', data, 'POST');


/**
 * 委托商类型
 */
export const customerTypePageList = data => fetch('/platform/sys/customerType/pageList', data, 'POST');

export const customerTypeIsEnable = id => fetch(`/platform/sys/customerType/isEnable/${id}`, {}, 'POST');

export const customerTypeDelete = id => fetch(`/platform/sys/customerType/delete/${id}`, {}, 'POST');

export const customerTypeAdd = data => fetch('/platform/sys/customerType/add', data, 'POST');

export const customerTypeDetail = id => fetch(`/platform/sys/customerType/detail/${id}`, {}, 'GET');

export const customerTypeUpdate = data => fetch('/platform/sys/customerType/update', data, 'POST');

export const customerTypeBasicInfoUpdate = data => fetch('/platform/sys/customerInfo/basicInfoUpdate', data, 'POST');

export const customerTypeInfoChange = data => fetch('/platform/sys/customerExamine/infoChange', data, 'POST');

/**
 * 委托车信息
 */
export const customerCarInfoPageList = data => fetch('/platform/sys/customerCarInfo/pageList', data, 'POST');

export const customerCarInfoIsEnable = id => fetch(`/platform/sys/customerCarInfo/isEnable/${id}`, {}, 'POST');

export const customerCarInfoDetail = id => fetch(`/platform/sys/customerCarInfo/detail/${id}`, {}, 'GET');

export const customerCarInfoAdd = data => fetch('/platform/sys/customerCarInfo/add', data, 'POST');

export const customerCarInfoUpdate = data => fetch('/platform/sys/customerCarInfo/update', data, 'POST');

export const customerCarInfoDelete = data => fetch(`/platform/sys/customerCarInfo/delete/${id}`, data, 'POST');

/**
 * 委托车车型  品牌
 */
export const brandBrandList = data => fetch('/platform/car/brand/carBrandList', data, 'GET');

// export const customerCarInfoIsEnable = ( id ) => fetch( `/platform/sys/customerCarInfo/isEnable/${id}`, {}, 'POST')

export const brandCarBrandDetail = id => fetch(`/platform/car/brand/carBrandDetail/${id}`, {}, 'GET');

export const brandAddCarBrand = data => fetch('/platform/car/brand/addCarBrand', data, 'POST');

export const brandUpdateCarBrand = data => fetch('/platform/car/brand/updateCarBrand', data, 'POST');
// 委托车品牌下拉框
export const brandGetCarBrandList = data => fetch('/platform/car/brand/getCarBrandList', data, 'GET');

// export const customerCarInfoDelete = ( data ) => fetch( `/platform/sys/customerCarInfo/delete/${id}`, data, 'POST')

/**
 * 委托商仓库管理
 */
export const customerWarehouseInfoPageList = data => fetch('/platform/sys/customerWarehouseInfo/pageList', data, 'POST');

export const customerWarehouseInfoIsEnable = id => fetch(`/platform/sys/customerWarehouseInfo/isEnable?id=${id}`, {}, 'POST');

export const customerWarehouseInfoDetail = id => fetch('/platform/sys/customerWarehouseInfo/detail', { id }, 'GET');

export const customerWarehouseInfoAdd = data => fetch('/platform/sys/customerWarehouseInfo/add', data, 'POST');

export const customerWarehouseInfoUpdate = data => fetch('/platform/sys/customerWarehouseInfo/update', data, 'POST');
// 委托车品牌下拉框
export const customerWarehouseInfoStatusSelectList = data => fetch('/platform/sys/customerWarehouseInfo/statusSelectList', data, 'GET');

// export const customerCarInfoDelete = ( data ) => fetch( `/platform/sys/customerCarInfo/delete/${id}`, data, 'POST')

/**
 * 委托车车型  型号
 */
export const modelCarModelList = data => fetch('/platform/car/model/carModelList', data, 'GET');

// export const customerCarInfoIsEnable = ( id ) => fetch( `/platform/sys/customerCarInfo/isEnable/${id}`, {}, 'POST')

export const modelCarBrandDetail = id => fetch(`/platform/car/model/carModelDetail/${id}`, {}, 'GET');

export const modelAddCarBrand = data => fetch('/platform/car/model/addCarModel', data, 'POST');

export const modelUpdateCarBrand = data => fetch('/platform/car/model/updateCarModel', data, 'POST');

// export const customerCarInfoDelete = ( data ) => fetch( `/platform/sys/customerCarInfo/delete/${id}`, data, 'POST')

/**
 * 公路供应商
 */
export const highwaySupplierList = data => fetch('/platform/highwaySupplier/highwaySupplierList', data, 'GET');

export const highwaySupplierStatusSelectList = data => fetch('/platform/highwaySupplier/statusSelectList', data, 'GET');

export const addHighwaySupplier = data => fetch('/platform/highwaySupplier/addHighwaySupplier', data, 'POST');

// 修改接口
export const editHighwaySupplier = data => fetch('/platform/highwaySupplier/update', data, 'POST');

// 变更接口
export const changeHighwaySupplier = data => fetch('/platform/highwaySupplier/basicInfoUpdate', data, 'POST');

// 终止合作
export const highwaySupplierDisable = data => fetch(`/platform/highwaySupplier/endCooperation?id=${data.id}&examine=${data.examine}`, data, 'POST');

// 取消审核
export const highwaySupplierEnable = data => fetch('/platform/highwaySupplier/cancelExamine', data, 'POST');

// 删除
export const highwaySupplierDelete = data => fetch('/platform/highwaySupplier/delHighway', data, 'POST');

export const highwaySupplierDetail = data => fetch(`/platform/highwaySupplier/updateDetail/${data.id}`, data, 'GET');

export const highwaySupplierBasicInfoUpdate = data => fetch('/platform/highwaySupplier/basicInfoUpdate', data, 'POST');

/**
 * 水路供应商
 */
export const pageList = data => fetch('/platform/waterSupplier/pageList', data, 'GET');

export const isEnable = id => fetch(`/platform/waterSupplier/isEnable/${id}`, {}, 'POST');

export const detail = id => fetch(`/platform/waterSupplier/detail/${id}`, {}, 'GET');

export const add = data => fetch('/platform/waterSupplier/add', data, 'POST');

export const update = data => fetch('/platform/waterSupplier/update', data, 'POST');

/**
 * 司机管理
 */
export const driverPageList = data => fetch('/platform/driver-basic-doc/pageList', data, 'GET');

export const driverAdd = data => fetch('/platform/driver-basic-doc/add', data, 'POST');

export const rePassword = id => fetch(`/platform/driver-basic-doc/rePassword/${id}`, {}, 'POST');

export const driverIsEnable = id => fetch(`/platform/driver-basic-doc/isEnable/${id}`, {}, 'POST');

export const driverDetail = id => fetch(`/platform/driver-basic-doc/detail/${id}`, {}, 'GET');
// 下拉查询赛选未绑定运输车辆的数据
export const driverSelectCarByDriver = id => fetch('/platform/highwayCar/selectCarByDriver', { 'highwayId': id }, 'GET');

export const driverUpdate = data => fetch('/platform/driver-basic-doc/update', data, 'POST');
// 绑定车辆详情
export const bindDetail = id => fetch(`/platform/driver-basic-doc/carDetails/${id}`, {}, 'GET');
// 绑定车辆
export const bindVehicle = data => fetch('/platform/driver-basic-doc/carBinding', data, 'POST');
// 解绑车辆
export const unbindVehicle = id => fetch(`/platform/driver-basic-doc/carUnbound/${id}`, {}, 'GET');

/**
 * 运输车管理
 */
export const truckPageList = data => fetch('/platform/highwayCar/pageList', data, 'GET');

export const truckAdd = data => fetch('/platform/highwayCar/add', data, 'POST');

export const truckIsEnable = id => fetch(`/platform/highwayCar/isEnable/${id}`, {}, 'POST');
// 运输车管理 所属供应商下拉
export const getHighwayParam = data => fetch('/platform/highwaySupplier/selectList', data, 'GET');
// 下拉查询赛选未绑定运输车辆的数据
export const driverSelectDriverByCar = data => fetch('/platform/driver-basic-doc/selectDriverByCar', data, 'GET');
// 司机详情查询
export const driverDetails = id => fetch(`/platform/highwayCar/driverDetails/${id}`, {}, 'GET');
// 绑定司机
export const driverVehicle = data => fetch('/platform/highwayCar/driverBinding', data, 'POST');
// 解绑司机
export const unDriverVehicle = id => fetch(`/platform/highwayCar/driverUnbound/${id}`, {}, 'GET');

export const truckDelete = id => fetch(`/platform/highwayCar/delete/${id}`, {}, 'POST');

export const truckUpdate = data => fetch('/platform/highwayCar/update', data, 'POST');

export const truckDetail = id => fetch(`/platform/highwayCar/detail/${id}`, {}, 'GET');

export const truckDocAdd = data => fetch('/platform/car-fault-doc/add', data, 'POST');

export const getDriverParam = data => fetch('/platform/paramCategoryAttr/getDriverParam', data, 'GET');

export const carFaultDcDelete = id => fetch(`/platform/car-fault-doc/delete/${id}`, {}, 'POST');

/**
 * 船舶管理
 */
export const shipPageList = data => fetch('/platform/supplierShip/pageList', data, 'GET');

export const shipAdd = data => fetch('/platform/supplierShip/add', data, 'POST');

export const shipUpdate = data => fetch('/platform/supplierShip/update', data, 'POST');

export const shipIsEnable = id => fetch(`/platform/supplierShip/isEnable/${id}`, {}, 'POST');

export const shipDelete = id => fetch(`/platform/supplierShip/delete/${id}`, {}, 'POST');

export const shipDetail = id => fetch(`/platform/supplierShip/detail/${id}`, {}, 'GET');

export const getWaterParam = data => fetch('/platform/param-category-attr/getWaterParam', data, 'GET');

/**
 * 船舱管理
 */
export const shipCabinPageList = data => fetch('/platform/sys/shipCabin/pageList', data, 'POST');

export const shipCabinAdd = data => fetch('/platform/sys/shipCabin/add', data, 'POST');

export const shipCabinUpdate = data => fetch('/platform/sys/shipCabin/update', data, 'POST');

export const shipCabinDelete = id => fetch(`/platform/sys/shipCabin/delete?id=${id}`, {}, 'POST');

export const shipCabinIsEnable = id => fetch(`/platform/sys/shipCabin/isEnable?id=${id}`, {}, 'POST');

/**
 * 港口及其它
 */
export const supplierPortOtherPageList = data => fetch('/platform/sys/supplierPortOther/pageList', data, 'GET');

export const supplierPortOtherIsEnable = id => fetch(`/platform/sys/supplierPortOther/isEnable/${id}`, {}, 'POST');

export const supplierPortOtherDetail = id => fetch(`/platform/sys/supplierPortOther/detail/${id}`, {}, 'GET');

export const typeSelectList = data => fetch('/platform/sys/supplierPortOther/typeSelectList', data, 'GET');

export const statusSelectList = data => fetch('/platform/sys/supplierPortOther/statusSelectList', data, 'GET');

export const supplierPortOtherAdd = data => fetch('/platform/sys/supplierPortOther/add', data, 'POST');

export const supplierPortOtherUpdate = data => fetch('/platform/sys/supplierPortOther/update', data, 'POST');
// 车道分页查询
export const vLine = data => fetch('/platform/sys/supplierPortOther/portOtherCabinPageList', data, 'GET');
// 删除
export const deleLine = id => fetch('/platform/sys/supplierPortOther/portOtherCabinDelete', id, 'POST');
// 启用禁用
export const startend = data => fetch('/platform/sys/supplierPortOther/portOtherCabinStatus', data, 'POST');
// 添加车道
export const addLine = data => fetch('/platform/sys/supplierPortOther/portOtherCabinInsert', data, 'POST');
// 修改
export const changeLine = data => fetch('/platform/sys/supplierPortOther/portOtherCabinUpdate', data, 'POST');

/**
 * 仓库管理
 */
export const storehouseList = data => fetch('/platform/storehouse/storehouseList', data, 'POST');

export const storehouseIsEnable = id => fetch(`/platform/storehouse/isEnable/${id}`, {}, 'POST');

export const storehouseDetail = id => fetch(`/platform/storehouse/storehouseDetail/${id}`, {}, 'GET');

export const addStorehouse = data => fetch('/platform/storehouse/addStorehouse', data, 'POST');

export const updateStorehouse = data => fetch('/platform/storehouse/updateStorehouse', data, 'POST');

/**
 * 楼层管理
 */
export const floorList = data => fetch('/platform/floor/floorList', data, 'POST');

export const floorIsEnable = id => fetch(`/platform/floor/isEnable/${id}`, {}, 'POST');

export const deleteFloor = id => fetch(`/platform/floor/deleteFloor/${id}`, {}, 'POST');

export const addFloor = data => fetch('/platform/floor/addFloor', data, 'POST');

export const updateFloor = data => fetch('/platform/floor/updateFloor', data, 'POST');

export const floorDetail = id => fetch(`/platform/floor/floorDetail/${id}`, {}, 'POST');

/**
 * 库位管理
 */
export const getLocationInfo = data => fetch('/platform/location/getLocationInfo', data, 'GET');

export const locationDetail = id => fetch(`/platform/location/locationDetail/${id}`, {}, 'GET');

/**
 * 库位管理
 */
export const addressDocPageList = data => fetch('/platform/address-doc/pageList', data, 'GET');

export const addressDocAdd = data => fetch('/platform/address-doc/add', data, 'POST');

export const addressDocIsEnable = id => fetch(`/platform/address-doc/isEnable/${id}`, {}, 'POST');

export const addressDocDelete = id => fetch(`/platform/address-doc/delete/${id}`, {}, 'POST');

export const addressDocUpdate = data => fetch('/platform/address-doc/update', data, 'POST');

/**
 * 区域管理
 */
// 分页查询
export const areaPageList = data => fetch('/platform/sys/tArea/pageList', data, 'GET');
// 新增
export const areaAdd = data => fetch('/platform/sys/tArea/add', data, 'POST');
// 修改
export const areaUpdate = data => fetch('/platform/sys/tArea/updateIdentification', data, 'POST');
// 删除
export const areaDelete = data => fetch(`/platform/sys/tArea/delete/${data}`, {}, 'GET');
// 获取上级城市
export const getSecondLevelArea = data => fetch('/platform/sys/tArea/getSecondLevelArea', data, 'GET');


/**
 * 港口管理
 */
// 分页查询
export const portManagePageList = data => fetch('/platform/sys/supplierPort/pageList', data, 'GET');
// 新增
export const portAdd = data => fetch('/platform/sys/supplierPort/add', data, 'POST');
// 修改
export const portUpdate = data => fetch('/platform/sys/supplierPort/update', data, 'POST');
// 删除
export const portDelete = data => fetch(`/platform/sys/supplierPort/delete/${data}`, {}, 'POST');
// 详情
export const portDetail = id => fetch(`/platform/sys/supplierPort/detail/${id}`, {}, 'GET');
// 获取供应商
export const supplierList = data => fetch('/platform/sys/supplierPortOther/sleectSupplierPortList', data, 'GET');
// 供应商绑定
export const supplierBind = data => fetch('/platform/sys/portAddress/supplierBindAndUnbind', data, 'POST');
// 车道
// 车道 -- 分页查询
export const lanePageList = data => fetch('/platform/sys/supplierPort/pageGarageList', data, 'GET');
// 车道 -- 新增
export const laneAdd = data => fetch('/platform/sys/supplierPort/addPortGarage', data, 'POST');
// 车道 -- 修改
export const laneUpdate = data => fetch('/platform/sys/supplierPort/updatePortGarage', data, 'POST');
// 车道 -- 删除
export const laneDelete = id => fetch(`/platform/sys/supplierPort/delPortGarage/${id}`, {}, 'POST');
// 车道 -- 启用/停用
export const laneIsEnable = data => fetch('/platform/sys/portAddress/portOtherCabinStatus', data, 'POST');


/**
 * 库位管理
 */
export const distributorPageList = data => fetch('/platform/distributor/distributorList', data, 'GET');

export const distributorAdd = data => fetch('/platform/distributor/addDistributor', data, 'POST');

export const distributorIsEnable = id => fetch(`/platform/distributor/updateStatus?id=${id}`, {}, 'POST');

export const distributorDetail = id => fetch(`/platform/distributor/distributorDetail/${id}`, {}, 'GET');

export const distributorUpdate = data => fetch('/platform/distributor/updateDistributor', data, 'POST');

export const distributorDelete = id => fetch(`/platform/distributor/delete/${id}`, {}, 'POST');
// 获取地址列表
export const distributorAddress = data => fetch('/platform/distributor/addressList', data, 'GET');
// 新增地址
export const addAddress = data => fetch('/platform/distributor/addAddress', data, 'POST');
// 修改地址
export const reviseAddress = data => fetch('/platform/distributor/updateAddress', data, 'POST');
// 删除地址
export const delAddress = data => fetch(`/platform/distributor/addAddress/${data}`, {}, 'POST');

/**
 * 字典管理
 */
// 左侧字典查询
export const getParamCategory = data => fetch('/platform/paramCategory/getParamCategory', data, 'GET');
// 字典分页查询
export const paramCategoryPageList = data => fetch('/platform/paramCategoryAttr/pageList', data, 'GET');
// 字典添加
export const paramCategoryAddCategoryAttr = data => fetch('/platform/paramCategoryAttr/addCategoryAttr', data, 'POST');
// 字典修改
export const paramCategoryUpdateCategoryAttr = data => fetch('/platform/paramCategoryAttr/updateCategoryAttr', data, 'POST');
// 启用禁用
export const paramCategoryIsEnable = id => fetch(`/platform/paramCategoryAttr/isEnable?id=${id}`, {}, 'POST');
// 删除
export const paramCategoryDelete = id => fetch(`/platform/paramCategoryAttr/delete?id=${id}`, {}, 'POST');
/**
 * 委托商托运费用结算
 */
// 委托商托运费结算分页
export const shippingFee = data => fetch('/platform/settlement/consignorLine/pageList', data, 'POST');
export const shippingBookMonth = data => fetch('/platform/settlement/consignorLine/updateStandingBookMonth', data, 'POST');
// 刷新结算
export const refreshAccount = data => fetch('/platform/settlement/consignorLine/addSettlementFreight', data, 'POST');
// 资源车刷新结算
export const consignmentRefreshAccount = data => fetch('/platform/settlement/consignorLine/addResourcesConsignorFreight', data, 'POST');
// 委托商-托运费结算-资源车-分页
export const consignmentList = data => fetch('/platform/settlement/consignorLine/resourceVehiclePageList', data, 'GET');
// 委托商-托运费补结算-常规车-分页
export const shippingFeePage = data => fetch('/platform/settlement/consignorLine/add/pageList', data, 'POST');
// 委托商-托运费补结算-常规车-刷新补结算
export const addSettlementFreightConsignor = data => fetch('/platform/settlement/consignorLine/add/addSettlementFreight', data, 'POST');
// 委托商-托运费补结算-常规车-刷新补结算-常规车到资源车
export const changeResource = data => fetchNew('/settlement/consignorLine/changeResource', data, 'POST');

// 委托商-托运费补结算-资源车-刷新补结算
export const addSettlementFreightResources = data => fetch('/platform/settlement/consignorLine/add/addResourcesConsignorFreight', data, 'POST');
// 委托商-托运费补结算-资源车-分页
export const consignmentPage = data => fetch('/platform/settlement/consignorLine/add/resourceVehiclePageList', data, 'GET');
/**
 * 供应商托运费用结算
 */
// 刷新结算
export const refreshSupplier = data => fetch('/platform/settlement/supplierLine/addSettlement', data, 'POST');
// 刷新补结算
export const refreshAddSupplier = data => fetch('/platform/settlement/supplierLine/add/addSettlement', data, 'POST');

/**
 * 委托商借结算管理
 */
// 修改台账月
export const updateBatchStandingBookMonth = data => fetch('/platform/settlement/consignorLine/updateBatchStandingBookMonth', data, 'POST');
// 修改台账月
export const updateStandingBookMonth = data => fetch('/platform/settlement/consignorLine/updateStandingBookMonth', data, 'POST');

/**
 * 供应商结算管理
 */
// 修改台账月
export const updateStandingBook = data => fetch('/platform/settlement/supplierLine/updateStandingBook', data, 'POST');

/**
 * 其它对账单
 */
// 暂缓开票对账单 列表查询
export const getOtherPageList = data => fetch('/platform/customer/accountSusBill/pageList', data, 'GET');
// 补结算管理 列表查询
export const getAccountPageList = data => fetch('/platform/customer/accountPriceDifference/pageList', data, 'GET');

/**
 * 字典管理
 */
// 新增字典
export const categoryAdd = data => fetch('/platform/paramCategory/addParamCategory', data, 'POST');
// 更新字典
export const categoryUpdate = data => fetch('/platform/paramCategory/updateParamCategory', data, 'POST');
// 详字典情
export const categoryDetail = data => fetch('/platform/paramCategory/paramCategoryDetail', data, 'GET');
// 删除字典
export const categoryDelete = id => fetch(`/platform/paramCategory/deleteParamCategory?id=${id}`, {}, 'POST');

// 委托商结算管理-托运费用结算-常规车
export const consignOrLinePriceRefresh = data => fetch('/platform/settlement/consignorLine/priceRefresh', data, 'POST');
// 委托商结算管理-托运费用结算-常规车
export const consignOrLineConsignor = data => fetch('/platform/settlement/consignorLine/priceRefreshResourcesConsignor', data, 'POST');
// 委托商结算管理-港口费用结算
export const consignOrPortPriceRefresh = data => fetch('/platform/settlement/consignorPort/priceRefresh', data, 'POST');
// 委托商结算管理-托运费用结算-公路/水路
export const supplierLinePriceRefresh = data => fetch('/platform/settlement/supplierLine/supplierPriceRefresh', data, 'POST');
// 委托商结算管理-港口费用结算-操作费
export const portOperatePriceRefreshRenovate = data => fetch('/platform/settlement/supplierPortOperation/portOperatePriceReshRenovate', data, 'POST');
// 委托商结算管理-港口费用结算-堆存费
export const priceRefreshRenovate = data => fetch('/platform/finance/stockpile/priceReshRenovate', data, 'POST');
// 委托商结算管理-提车费
export const supplierHandoverPriceRefresh = data => fetch('/platform/settlement/supplierHandover/priceReshRenovate', data, 'POST');
// eslint-disable-next-line no-shadow
export const importConsignorOilPriceLink = (data) => fetch(`/platform/customer/account/importConsignorOilPriceLink?title=${data.title}&number=${data.number}`, {}, 'POST');

// 供应商管理
export const supplierInfoTransition = data => fetch('/platform/supplierInfoTransition/pageList', data, 'GET');
export const getSupplierMasterDate = data => fetch(`/platform/inspur/getSupplierMasterDate?type=${data.type}&nameChs=${data.nameChs}`, data, 'POST');
export const supplierSynchronize = data => fetch('/platform/supplierInfoTransition/perfect', data, 'POST');
